import { FC } from 'react';

import { ContentLoader } from 'components/design-system/ContentLoader';

const loaders = Array.from({ length: 15 }, (_, index) => index);

export const AllBidsLoaderTestIds = {
  container: 'all-bids-loader-container',
  loader: 'all-bids-loader-loader'
};

export const AllBidsLoader: FC = () => (
  <div data-testid={AllBidsLoaderTestIds.container} className='w-100 px-2'>
    {loaders.map(key => (
      <div data-testid={AllBidsLoaderTestIds.loader} key={key} className='d-flex py-3 w-100'>
        <div className='w-10'>
          <ContentLoader isDark width={14} />
        </div>
        <ContentLoader isDark className='' width={50} />
        <div className='w-25'>
          <ContentLoader isDark className='' width={50} />
        </div>
        <div className='flex-1 d-flex justify-content-end pe-2'>
          <ContentLoader isDark className='' width={160} />
        </div>
      </div>
    ))}
  </div>
);
